// extracted by mini-css-extract-plugin
module.exports = {"body":"+aPKc","bottomSheetContainer":"m9716","header":"MUKkX","title":"v3dLK","closeTip":"KBpQQ"};